/**
 * ERP（カクテル）側の制限値。
 *
 * サーバー側 api/services/order.py の ERP_ITEM_LIMIT / ERP_ITEM_MAX と対になる。
 * 画面は手戻りを減らすために先に止めるだけで、実際の担保はサーバー側で行う。
 * 値を変えるときは両方を直すこと。
 */

/**
 * 1伝票あたりの明細行数。この行数「以上」はERPへ書き込まない。
 *
 * カクテルの上限は1,000行で、超えると取込時に「1000行を超えています。」で弾かれる。
 * 弾かれた行は伝票にならずワークテーブルに残るだけなので、余裕を見て990行以上を
 * 書込み不可とする（三興バルブ様 門田様の指定）。
 */
export const ERP_ITEM_LIMIT = 990;

/** 実際に書き込める明細行数の上限（989行）。 */
export const ERP_ITEM_MAX = ERP_ITEM_LIMIT - 1;
